import { render, staticRenderFns } from "./allCases.vue?vue&type=template&id=7dd980f2&scoped=true&"
import script from "./allCases.vue?vue&type=script&lang=js&"
export * from "./allCases.vue?vue&type=script&lang=js&"
import style0 from "./allCases.vue?vue&type=style&index=0&id=7dd980f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd980f2",
  null
  
)

export default component.exports